// How an order status (backend services/order_status.py) reads as a chip: the
// same on the Orders tab, Deliveries and the plan page. Labels are status.* in i18n.

import type { OrderStatus } from "../types";

export const STATUS_TONE: Record<OrderStatus, string> = {
  available: "neutral",
  planned: "neutral",
  scheduled: "accent",
  left_depot: "accent",
  at_drop: "accent",
  delivered: "ok",
  delivery_exception: "warn",
  not_delivered: "warn",
};
